
  import React from "react"
  import Component from "/Users/jayharris/Desktop/Nicer/internal/slackchat/website/src/layouts/index.js"
  import data from "/Users/jayharris/Desktop/Nicer/internal/slackchat/website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js